import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "@/components/Header";
import { api } from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

export default function Share() {
  const { shareId } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.blitzShare(shareId).then(setData).catch(() => setErr("Score not found."));
  }, [shareId]);

  return (
    <div className="min-h-screen text-white" style={{ background: "var(--kl-navy-deep)" }}>
      <Header />
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-12 relative">
        <div className="absolute top-20 left-1/2 -translate-x-1/2 w-[500px] h-[500px] rounded-full opacity-15 blur-3xl pointer-events-none" style={{ background: "radial-gradient(circle, rgba(230,57,70,0.5), transparent 60%)" }} />
        <div className="relative z-10 font-mono-kl text-xs uppercase tracking-[0.3em] text-[color:var(--kl-red)]">
          <span className="kl-accent-line mr-3" />PROCTORLY · BLITZ SCORECARD
        </div>
        {err && <p className="mt-4 text-white/80 relative z-10">{err}</p>}
        {data && (
          <div className="mt-4 bg-white text-[color:var(--kl-ink)] border border-black/10 p-8 rounded-md relative z-10" data-testid="share-card">
            <div className="font-display text-2xl">KIBA<span className="text-[color:var(--kl-red)]">/</span>LABS</div>
            <div className="font-display text-5xl md:text-7xl uppercase mt-3 leading-[0.9]">{data.name}</div>
            <div className="font-mono-kl text-xs uppercase tracking-widest text-black/50 mt-4">{data.topic_label}</div>
            <div className="flex items-baseline gap-3 mt-2">
              <div className="font-display text-9xl text-[color:var(--kl-red)] leading-none">{data.score}</div>
              <div className="font-display text-3xl text-black/30">/10</div>
            </div>
            <div className="font-display text-xl uppercase mt-1">{data.badge}</div>
            <p className="mt-4 text-black/70 italic">"{data.feedback}"</p>
            <Link to="/" className="btn-submit inline-flex mt-5">
              Take the Blitz yourself <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
